<template>
  <v-tabs
    :center-active="$vuetify.breakpoint.xsOnly"
    :vertical="$vuetify.breakpoint.smAndUp"
    style="min-height: 100%"
    class="options"
    v-model="tabStringOptions"
  >
    <p class="d-none d-sm-block font font--action-small-2" style="margin-top: 24px">Мои настройки</p>
    <v-tab :ripple="false" :href="`#tab-1`" class="font" style="text-transform: none"
      >Профиль <span v-if="flNameIsNotFilled" class="profile-is-not-filled ml-sm-2"></span
    ></v-tab>
    <v-tab :ripple="false" v-if="canSeeBilling" :href="`#tab-2`" class="font" style="text-transform: none"
      >Реквизиты <span v-if="reqIsNotFilled" class="profile-is-not-filled ml-sm-2"></span
    ></v-tab>
    <v-tab :ripple="false" :href="`#tab-3`" class="font" style="text-transform: none" v-if="canAddUser"
      >Сотрудники</v-tab
    >
    <p class="d-none d-sm-block font font--action-small-2">Общие</p>
    <v-tab :ripple="false" :href="`#tab-4`" class="font" style="text-transform: none">Связь с банком</v-tab>
    <v-tab :ripple="false" :href="`#tab-5`" class="font" style="text-transform: none">Клиенты</v-tab>

    <v-tab-item class="pa-4 pa-sm-8" :value="`tab-1`">
      <!-- v-if чтобы монтировалось только когда настройки открыты -->
      <OptionProfile v-if="$store.state.common.showOptions" />
    </v-tab-item>
    <v-tab-item class="pa-4 pa-sm-8" :value="`tab-2`" v-if="canSeeBilling">
      <!-- v-if чтобы монтировалось только когда настройки открыты -->
      <OptionRequisite v-if="$store.state.common.showOptions" />
    </v-tab-item>
    <v-tab-item class="pa-4 pa-sm-8" v-if="canAddUser" :value="`tab-3`">
      <OptionStaff />
    </v-tab-item>
    <v-tab-item class="pa-4 pa-sm-8" :value="`tab-4`">
      <OptionCommunication />
    </v-tab-item>
    <v-tab-item class="pa-4 pa-sm-8" :value="`tab-5`">
      <OptionClientele />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import OptionProfile from "@/components/options/OptionProfile.vue";
import OptionStaff from "@/components/options/OptionStaff.vue";
import OptionRequisite from "@/components/options/OptionRequisite.vue";
import OptionCommunication from "@/components/options/OptionCommunication.vue";
import OptionClientele from "@/components/options/OptionClientele.vue";
import SidePanel from "@/components/common/SidePanel";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("profile", ["reqIsNotFilled", "flNameIsNotFilled", "canAddUser", "canSeeBilling"]),
    tabStringOptions: {
      get() {
        return this.$store.state.common.tabStringOptions;
      },
      set(value) {
        this.$store.commit("common/tabShowOptions", value);
      },
    },
  },
  components: {
    OptionProfile,
    OptionRequisite,
    OptionCommunication,
    OptionClientele,
    OptionStaff,
  },
  // methods: {
  //    ...mapMutations("common", ["tabShowOptions"]),
  // }
};
</script>

<style scoped>
.v-application p {
  margin-bottom: 12px;
  margin-top: 12px;
  margin-left: 24px;
  color: rgba(0, 0, 0, 0.499972);
}

@media (max-width: 600px) {
  .tabs-none {
    display: none;
  }
  .v-tab {
    padding: 0px 14px !important;
  }
  .tab-text {
    font-size: 14px;
  }
  .close {
    order: 2;
  }
  .title {
    order: 1;
  }
}
</style>
